import React from "react";
import { Outlet } from "react-router-dom";
import LegalTopBar from "./LegalTopBar";

export default function LegalLayout() {
  return (
    <main className="legal-main">
      <LegalTopBar />
      <section className="legal-container">
        <Outlet />
      </section>
    </main>
  );
}
